import Vue from 'vue'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import SelectButton from '@/components/button/SelectButton.vue'
import FormInput from '@/components/form/FormInput.vue'
import FormWrapper from '@/components/form/FormWrapper.vue'
import TableNoData from '@/components/table/TableNoData.vue'
import Info from '@/components/info/Info.vue'
import ButtonLoading from '@/components/button/ButtonLoading.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import TableBusy from '@/components/table/TableBusy.vue'
import PaperSimple from '@/components/paper/PaperSimple.vue'
import InputField from '@/components/form/InputField.vue'
import CustomSelect from '@/components/form/CustomSelect.vue'
import CustomAlert from '@/components/alert/CustomAlert.vue'
import Parent from '@/components/Parent.vue'

Vue.component('GjIcon', GjIcon)
Vue.component('select-button', SelectButton)
Vue.component('formInput', FormInput)
Vue.component('form-wrapper', FormWrapper)
Vue.component('no-data', TableNoData)
Vue.component('info', Info)
Vue.component('button-loading', ButtonLoading)
Vue.component('loading-page', LoadingPage)
Vue.component('table-busy', TableBusy)
Vue.component('paper-simple', PaperSimple)
Vue.component('input-field', InputField)
Vue.component('custom-select', CustomSelect)
Vue.component('custom-alert', CustomAlert)
Vue.component('parent', Parent)
